import { FunctionComponent } from "react";

import { Typography } from "@digital-services/ui";

import { useUserContext } from "@hooks/useUserContext";

const UserProfile: FunctionComponent = () => {
  const { user } = useUserContext();

  return (
    <div
      className="absolute top-0 right-0 flex flex-col items-end"
      data-testid="user-profile"
    >
      <Typography variant="sectionTitle" className="pt-2 pr-5 text-right">
        {user.name}
      </Typography>
      <Typography className="pt-2 pr-5 text-right" variant="smallTitle">
        {user.roles.toString()}
      </Typography>
    </div>
  );
};

export default UserProfile;
